/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.slice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import XSwitch from "vux/src/components/x-switch/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Rater from "vux/src/components/rater/index.vue"; // this line is trasformed by vux-loader
import SelectPicker from '@/components/Base/SelectPicker';
import ImgUpload from '@/components/ImgUpload';
import FileUpload from '@/components/FileUpload';
import ScanCell from '@/components/ScanCell';
import PositionCell from '@/components/PositionCell';
import PopupCheckList from './PopupCheckList';
import SmyXAddress from './SmyXAddress';
import SmyCheckBox from './SmyCheckBox';
import utils from '@/utils/utils';
import { calcFormula } from '@/utils/calculator';
import axios from 'axios';
import WriteExecute from '@/pages/project/detail/OrderReturnReceipt/WriteExecute';
import DatetimeRange from './DatetimeRange';
function flatArr() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return arr.reduce(function (p, c) {
    p = p.concat(c).concat(flatArr(c.dropList));
    return p;
  }, []);
}
export default {
  name: 'CustomFormList',
  components: {
    DatetimeRange: DatetimeRange,
    WriteExecute: WriteExecute,
    Cell: Cell,
    SelectPicker: SelectPicker,
    PopupCheckList: PopupCheckList,
    XInput: XInput,
    XTextarea: XTextarea,
    Group: Group,
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Datetime: Datetime,
    XSwitch: XSwitch,
    ImgUpload: ImgUpload,
    FileUpload: FileUpload,
    ScanCell: ScanCell,
    PositionCell: PositionCell,
    SmyCheckBox: SmyCheckBox,
    SmyXAddress: SmyXAddress,
    Rater: Rater
  },
  props: {
    data: {
      type: Array
    },
    // 表单label标签宽度
    labelWidth: {
      type: Number,
      default: 120
    },
    getValueName: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      list: [],
      writeShow: false,
      form: {
        signImg: ''
      },
      currentIndex: -1
    };
  },
  watch: {
    data: {
      handler: function handler(val) {
        var _this = this;
        // 深拷贝
        var list = utils.deepCopy(this.data);
        // 数据格式化
        list.forEach( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(v) {
            var value, pos;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if ([3, 8].indexOf(v.type) !== -1) {
                      v.dropList = v.dropList.map(function (item) {
                        return {
                          value: item.id + '',
                          name: item.value
                        };
                      });
                    }
                    if (!(v.type === 21)) {
                      _context.next = 8;
                      break;
                    }
                    _context.t0 = _this;
                    _context.t1 = v;
                    _context.next = 6;
                    return _this.loadTxtImg(v.tfvvalue);
                  case 6:
                    _context.t2 = _context.sent;
                    _context.t0.$set.call(_context.t0, _context.t1, 'tfvvalue', _context.t2);
                  case 8:
                    if ([18].indexOf(v.type) !== -1) {
                      _this.$set(v, '_isShow', false);
                      _this.$set(v, '_name', 'false');
                      _this.$set(v, 'arrvalue', v.ovalue ? v.ovalue.split(',').map(Number) : []);
                    }
                    if (!v.ovalue) {
                      // 空数据格式化
                      if (v.type === 3) {
                        v.ovalue = '';
                      } else if ([7, 16].indexOf(v.type) !== -1) {
                        v.ovalue = 0;
                      } else {
                        v.ovalue = [];
                      }
                    } else {
                      // 数据回显
                      if ([3, 7, 16].indexOf(v.type) === -1) {
                        // 多选数据过滤
                        if (v.type === 8) {
                          value = v.ovalue.split(',');
                          v.ovalue = [];
                          if (value.length > 0) {
                            value.forEach(function (item) {
                              if (v.dropList.some(function (drop) {
                                return drop.value === item;
                              })) {
                                v.ovalue.push(item);
                              }
                            });
                          }
                        } else {
                          v.ovalue = v.ovalue.split(',');
                        }
                      } else {
                        if ([7, 16].indexOf(v.type) !== -1) {
                          v.ovalue = Number(v.ovalue);
                        }
                      }
                    }
                    if (!v.tfvvalue) {
                      // 空数据格式化
                      if ([10, 15, 26].indexOf(v.type) !== -1) {
                        v.tfvvalue = '';
                        v.ovalue = [];
                      } else {
                        v.tfvvalue = '';
                      }
                    } else {
                      // 数据回显
                      if ([10, 15, 26].indexOf(v.type) !== -1) {
                        // v.tfvvalue = v.tfvvalue
                        v.ovalue = v.tfvvalue.split(',');
                      } else if (v.type === 4) {
                        v.tfvvalue = new Date(utils.date.formatDate(v.tfvvalue)).Format('YYYY-MM-DD');
                      } else if (v.type === 5) {
                        // v.tfvvalue = new Date(utils.date.formatDate(v.tfvvalue)).Format('HH:mm')
                      } else if (v.type === 6) {
                        v.tfvvalue = new Date(utils.date.formatDate(v.tfvvalue)).Format('YYYY-MM-DD HH:mm');
                      } else if (v.type === 11) {
                        pos = v.tfvvalue.split(',');
                        if (pos[3] && pos[4]) {
                          v.ovalue = [pos[3], pos[4]];
                        } else {
                          v.ovalue = [];
                        }
                      }
                    }
                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        this.list = list;
      }
    },
    list: {
      handler: function handler(list) {
        var _this2 = this;
        try {
          var data = utils.deepCopy(list);
          // 数据格式化
          var actions = new Map([[/^(8|9|10|15|18|26)$/, function (val) {
            return Array.isArray(val.ovalue) ? val.ovalue.join(',') : '';
          }], [/^(3|7|16)$/, function (val) {
            return val.ovalue;
          }], [/^[456]$/, function (val) {
            return val.tfvvalue ? val.tfvvalue : '';
          }], [/^default$/, function (val) {
            return val.tfvvalue ? val.tfvvalue : '';
          }]]);

          // 获取选项等中文信息
          var valueNameActions = new Map([[/^3$/, function (val) {
            var data = val.dropList.find(function (item) {
              return Number(item.value) === Number(val.ovalue);
            });
            return data ? data.name : '';
          }], [/^[456]$/, function (val) {
            return val.tfvvalue ? val.tfvvalue : '';
          }], [/^8$/, function (val) {
            return val.dropList.filter(function (item) {
              return val.ovalue.indexOf(item.value) !== -1;
            }).map(function (item) {
              return item.name;
            }).join(',') || '';
          }], [/^9$/, function (val) {
            return val.tfvvalue ? val.tfvvalue : '';
          }], [/^(7|16)$/, function (val) {
            return val.ovalue === 1 ? i18n.tc("86") : i18n.tc("87");
          }], [/^(10|15|26)$/, function (val) {
            return Array.isArray(val.ovalue) ? val.ovalue.join(',') : '';
          }], [/^11$/, function (val) {
            return val.tfvvalue.split(',')[0] ? val.tfvvalue.split(',')[0] : '';
          }], [/^(18)$/, function (val) {
            return val._name || flatArr(val.dropList).filter(function (item) {
              return val.ovalue.includes(item.id);
            }).map(function (item) {
              return item.value;
            }).join(',') || '';
          }], [/^default$/, function (val) {
            return val.tfvvalue ? val.tfvvalue : '';
          }]]);

          // change事件，数据格式化并 emit
          var arr = data.map(function (val) {
            var obj = val;
            obj.value = _toConsumableArray(actions).find(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 1),
                key = _ref3[0];
              return key.test("".concat(val.type)) || key.test('default');
            })[1](val);
            if (_this2.getValueName) {
              obj.name = _toConsumableArray(valueNameActions).find(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 1),
                  key = _ref5[0];
                return key.test("".concat(val.type)) || key.test('default');
              })[1](val);
            }
            return obj;
          });
          this.$emit('on-change', arr);
        } catch (error) {
          console.log('AutoConsole: handler -> error', error);
        }
      },
      deep: true
    }
  },
  methods: {
    loadTxtImg: function loadTxtImg(url) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (url) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return", '');
              case 2:
                if (!url.includes('data:image')) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return", url);
              case 4:
                _context2.next = 6;
                return axios({
                  method: 'get',
                  url: url
                });
              case 6:
                res = _context2.sent;
                return _context2.abrupt("return", res.data);
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getWaterMask: function getWaterMask(form) {
      var _form$fieldAttributeL, _form$fieldAttributeL2;
      return Boolean(Number(form === null || form === void 0 ? void 0 : (_form$fieldAttributeL = form.fieldAttributeList) === null || _form$fieldAttributeL === void 0 ? void 0 : (_form$fieldAttributeL2 = _form$fieldAttributeL.find(function (v) {
        return v.type === 1001;
      })) === null || _form$fieldAttributeL2 === void 0 ? void 0 : _form$fieldAttributeL2.value));
    },
    getCallNumber: function getCallNumber(form) {
      var _form$fieldAttributeL3, _form$fieldAttributeL4;
      return form === null || form === void 0 ? void 0 : (_form$fieldAttributeL3 = form.fieldAttributeList) === null || _form$fieldAttributeL3 === void 0 ? void 0 : (_form$fieldAttributeL4 = _form$fieldAttributeL3.find(function (v) {
        return v.type === 2001;
      })) === null || _form$fieldAttributeL4 === void 0 ? void 0 : _form$fieldAttributeL4.value;
    },
    callbackSign: function callbackSign(sign) {
      if (!this.list[this.currentIndex]) return;
      this.list[this.currentIndex].tfvvalue = sign;
    },
    handleSign: function handleSign(item, index) {
      var _this3 = this;
      this.currentIndex = index;
      this.writeShow = true;
      this.$nextTick(function () {
        setTimeout(function () {
          var _this3$$refs, _this3$$refs$WriteExe;
          (_this3$$refs = _this3.$refs) === null || _this3$$refs === void 0 ? void 0 : (_this3$$refs$WriteExe = _this3$$refs.WriteExecute) === null || _this3$$refs$WriteExe === void 0 ? void 0 : _this3$$refs$WriteExe.clear();
        }, 200);
      });
    },
    calcValue: function calcValue(form) {
      var _form$fieldAttributeL5, _form$fieldAttributeL6;
      return calcFormula({
        formula: (form === null || form === void 0 ? void 0 : (_form$fieldAttributeL5 = form.fieldAttributeList) === null || _form$fieldAttributeL5 === void 0 ? void 0 : (_form$fieldAttributeL6 = _form$fieldAttributeL5.find(function (v) {
          return v.type === 1901;
        })) === null || _form$fieldAttributeL6 === void 0 ? void 0 : _form$fieldAttributeL6.value) || '',
        data: this.list,
        format: function format(p, e) {
          p[e.id] = e.tfvvalue;
          return p;
        }
      });
    },
    handleCall: function handleCall(phoneNumber) {
      this.$DingTalk.biz.telephone.showCallMenu({
        phoneNumber: phoneNumber,
        // 期望拨打的电话号码
        code: '+86',
        // 国家代号，中国是+86
        showDingCall: true,
        // 是否显示钉钉电话
        onSuccess: function onSuccess() {},
        onFail: function onFail() {}
      });
    },
    spliteHyperLink: function spliteHyperLink() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      url = url || '';
      var index = url.indexOf(',') > 0 ? url.indexOf(',') : 0;
      return [url.slice(0, index), url.slice(index + 1)];
    },
    // 数据重置
    /* eslint-disable no-return-assign */
    resetFormFields: function resetFormFields() {
      var actions = new Map([[/^(3|8|18)$/, function (val) {
        return val.ovalue = [];
      }], [/^(7|16)$/, function (val) {
        return val.ovalue = 0;
      }], [/^[456]$/, function (val) {
        return val.tfvvalue = '';
      }], [/^(9|10|11|15|26)$/, function (val) {
        val.tfvvalue = '';
        val.ovalue = [];
      }], [/^default$/, function (val) {
        return val.tfvvalue = '';
      }]]);
      this.list.forEach(function (item) {
        ;
        _toConsumableArray(actions).find(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 1),
            key = _ref7[0];
          return key.test("".concat(item.type)) || key.test('default');
        })[1](item);
      });
    },
    xAddressOnChange: function xAddressOnChange(item, val, val2) {
      item.tfvvalue = val2.join(',');
    },
    numberValidate: function numberValidate(value) {
      if (!/^[0-9]+.?[0-9]*$/.test(value)) {
        return {
          valid: false,
          msg: i18n.tc("367")
        };
      }
      return {
        valid: true
      };
    },
    // 表单验证（自定义操作事件）
    formValidateFuc: function formValidateFuc() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var _iterator = _createForOfIteratorHelper(_this4.list),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var val = _step.value;
            if ([19, 11, 14, 17].includes(val.type)) continue; // c端不支持定位组件
            if (val.type === 2) {
              if (val.tfvvalue !== '' && !/^[0-9]+.?[0-9]*$/.test(val.tfvvalue)) {
                reject(val);
              }
            }
            if ([23, 24, 25].includes(val.type) && val.is_required && val.is_required === 1) {
              if (val.tfvvalue === '' || val.tfvvalue === ',') {
                reject(val);
              }
            }
            if (val.is_required && val.is_required === 1) {
              if ([3, 7, 8, 9, 10, 15, 18, 26].indexOf(val.type) !== -1) {
                if (val.ovalue.length === 0) {
                  reject(val);
                }
              } else {
                if (!val.tfvvalue) {
                  reject(val);
                }
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        resolve(true);
      });
    },
    // 表单验证（已定义必填提示操作事件）
    formValidate: function formValidate() {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        _this5.formValidateFuc().then(function (res) {
          resolve(true);
        }).catch(function (e) {
          _this5.$vux.toast.text(i18n.tc("368") + e.name);
          resolve(false);
        });
      });
    }
  },
  created: function created() {}
};